import React from "react";
import Dashboard from "./Dashboard";
import TopBar from "./TopBar";

function Home() {
  return (
    <>
      <TopBar />
      <Dashboard />
    </>
  );
}

export default Home;
